export type AudioPreferences = {music:boolean;gameMuted?:boolean}

// An explicit unmute also restores music disabled by the former music-only button.
export function toggledGameAudio(state:AudioPreferences): AudioPreferences {
  const gameMuted=!state.gameMuted
  return {gameMuted,music:gameMuted?state.music:true}
}

// Call inside user gestures as well as effects. Browsers may reject the initial
// page-load attempt; a later interaction retries without changing preferences.
export function resumeGameMusic(audio:HTMLAudioElement|null,preferences:AudioPreferences) {
  if(!audio||preferences.gameMuted||!preferences.music)return
  audio.muted=false
  audio.volume=.48
  if(audio.paused)void audio.play().catch((error:DOMException)=>{
    if(error.name!=='NotAllowedError'&&error.name!=='AbortError')console.warn('Game music could not start',error.message)
  })
}
